import React, {Component} from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {ATTR_DEPENDS, ATTR_OBJ_ID} from "./ProsConnect";
import {ObsDependencyItem, prosMultiFilterText, canAddEditObs, TextContent} from './ProsCommonUi';
import {ATTR_EXPIRATION, ATTR_TEXT, STR_NO_VALUE, OBJ_TYPE_ITM_REF, UI_LISTED_ELEMENTS_LIMIT} from "./ProsConnect";
import {ATTR_OBS_ID, getItemText} from "./ProsConnect";
import {prosAppNotifWait} from "./ProsAppNotif"
import Spacer from "../components/Spacer";
import BasicButton from "../components/BasicButton";
import TextButton from "../components/TextButton";
import Pagination from "../components/Pagination";
import BasicModal from "../components/BasicModal";

export function getThisDependsOn(obs, everyObs, add_self = true) {
    let depends = everyObs
        .filter(o => obs[ATTR_DEPENDS] && obs[ATTR_DEPENDS].split(';').indexOf(o[ATTR_OBJ_ID]) >= 0)
    if (add_self && depends.length > 0) {
        depends.push(obs)
        depends.sort((a, b) => a[ATTR_EXPIRATION] - b[ATTR_EXPIRATION])
    }
    return depends
}

export function getDependsOnThis(obs, everyObs, add_self = true) {
    let depends = everyObs
        .filter(o => o[ATTR_DEPENDS] && o[ATTR_DEPENDS].split(';').indexOf(obs[ATTR_OBJ_ID]) >= 0)
    if (add_self && depends.length > 0) {
        depends.push(obs)
        depends.sort((a, b) => a[ATTR_EXPIRATION] - b[ATTR_EXPIRATION])
    }
    return depends
}

export function renderThisDependsOnForHistory(obs, everyObs) {
    let depends_ids = prosConnect.getValidAttr(obs, ATTR_DEPENDS, '').split(';')
    let depends = everyObs.filter(o => depends_ids.indexOf(o[ATTR_OBJ_ID]) >= 0)
    if (depends.length <= 0) {
        return null
    }
    depends.push(obs)
    depends.sort((a, b) => a[ATTR_EXPIRATION] - b[ATTR_EXPIRATION])

    return <div
            onClick={(evt) => {
                evt.stopPropagation()
            }}
            className={"dependencies margin-top"
        }>
        <h6>Yhteydet tästä</h6>
        <div className={"dependencies-list"}>
            {depends.map((dependency, i) =>
                (<ObsDependencyItem key={i}
                    dependency={dependency}
                    active_obs={obs}
                />)
            )}
        </div>
    </div>
}

export default class ProsObsDependencyListing extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            results: [],
            results_length: 0,
            showListing: false,
            resultsPageStart: 0
        }
        this.searchObservations = this.searchObservations.bind(this)
        this.maxResultsPages = 3
    }

    async saveDependencyEdit(obs, dependency, add = true) {

        if(add) prosAppNotifWait("Luodaan yhteyttä")
        else prosAppNotifWait("Poistetaan yhteys")
        // Refresh projects?
        await prosConnect.getActiveProject().awaitRefreshProjectObjectsFromAws();

        // Read depends
        let depends = prosConnect.getValidAttr(obs, ATTR_DEPENDS, '').split(';')
        // Remove empty values
        while (depends.indexOf('') !== -1) {
            depends.splice(depends.indexOf(''), 1)
        }
        let dependent_obj_id = prosConnect.getValidAttr(dependency, ATTR_OBJ_ID, STR_NO_VALUE)
        // Do not depend on itself
        if (obs[ATTR_OBJ_ID] === dependent_obj_id) {
            return
        }
        // Add or remove dependency
        if (add) {
            if (depends.indexOf(dependent_obj_id) < 0) {
                depends.push(dependency[ATTR_OBJ_ID])
                this.filter_out_list.push(dependency)
            }
        } else {
            if (depends.indexOf(dependent_obj_id) >= 0) {
                depends.splice(depends.indexOf(dependency[ATTR_OBJ_ID]), 1)
                this.filter_out_list.splice(this.filter_out_list.indexOf(dependency), 1)
            }
        }
        this.searchObservations(this.state.searchText)
        // Save changed dependency
        await prosConnect.getActiveProject().awaitUpdateItemAttrs(obs,
            {[ATTR_DEPENDS]: depends.join(';')}, true)
    }

    getMatchingToFilter(filterTxt, everyObs) {
        return everyObs.filter(obs => prosMultiFilterText(filterTxt || '', getItemText(obs))
            || prosMultiFilterText(filterTxt || '', prosConnect.getValidAttr(obs, ATTR_OBS_ID, '')))
    }

    searchObservations(text) {
        let results = this.getMatchingToFilter(text, prosConnect.getActiveProject().getObservations())
            .filter(result => ! this.filter_out_list.includes(result))
        this.setState({
            searchText: text,
            results: results.slice(0, UI_LISTED_ELEMENTS_LIMIT * this.maxResultsPages),
            results_length: results.length,
        })
    }

    renderSearchResult(result, obs) {
        return <li key={"dlist" + result.obj_id}
            onClick={() => {
                this.saveDependencyEdit(obs, result)
                this.setState({
                    searchText: '',
                    resultsPageStart: 0
                })
            }}
            title="Lisää yhteys"
        ><TextContent text={(result.obs_id ?  result.obs_id + " " : "") + result[ATTR_TEXT]} maxLength={100} /></li>
    }

    renderSearchAndAddDependencyObsTextButton() {
        return <div
                onClick={(evt) => {
                    evt.stopPropagation()
                }}
                className={"btn-set_center"}
            >
            <TextButton
                label={"Luo yhteyksiä"}
                icon={"link"}
                placeholder={"Etsi kirjausta"}
                onChange={(val)=> {
                    if(val === '') this.setState({
                        searchText: '',
                        results: [],
                        results_length: 0
                    })
                }}
                onSubmit={val => {
                    this.searchObservations(val)
                }}
                value={this.state.searchText}
                info={"Luo yhteyksiä kirjausten välille."}
                inputType={"search"}//go in pairs
                keepActive={true}//go in pairs
                isActive={this.state.searchText.length > 0}
                btnType={!canAddEditObs() ? "locked" : null}
            />
        </div>
    }

    renderSearchResults(obs) {
        if (this.state.searchText.length < 1) {
            return null
        }
        let maxListedItems = this.maxResultsPages * UI_LISTED_ELEMENTS_LIMIT
        if(maxListedItems > this.state.results.length) maxListedItems = this.state.results.length
        const pagination = maxListedItems >= UI_LISTED_ELEMENTS_LIMIT ? <Pagination
                btnClass={"3rd"}
                currentPage={this.state.resultsPageStart}
                allItemsInt={maxListedItems}
                chunk={UI_LISTED_ELEMENTS_LIMIT}
                callback={val => {
                    this.setState({
                        resultsPageStart: val
                    })
                }}
                showPages
                disableLoop
                className={"btn-set"}
            /> : null

        let listedResults = this.state.results.slice(this.state.resultsPageStart, this.state.resultsPageStart + UI_LISTED_ELEMENTS_LIMIT)
        let noteCount = this.state.results_length > UI_LISTED_ELEMENTS_LIMIT ?
            <li>
                {this.maxResultsPages * UI_LISTED_ELEMENTS_LIMIT < this.state.results_length
                    ? <p>Löytyy yli <strong>{this.maxResultsPages * UI_LISTED_ELEMENTS_LIMIT}</strong> ({this.state.results_length}). Rajaa hakua.</p> : null}
                {pagination}
            </li> :
            <li className={"display-flex element-set valign-center"}>
                <p className={"flex-grow text-center margin-0"}>Löytyy <strong>{listedResults.length}</strong></p>
                <BasicButton
                icon={"times"}
                action={()=> this.setState({ searchText: ''})}
            /></li>
        if(this.state.results_length < 1 && this.state.searchText.length > 0) noteCount = <li><p>Ei osumia.</p></li>
        return <ul>
            {listedResults.map(result =>
                (this.renderSearchResult(result, obs))
            )}
            {noteCount}
        </ul>
    }

    renderObsDepends(obs, depends, text, this_depends_on) {
        if (depends.length <= 1) {
            return null
        }
        return <>
            {text ? <h6>{text}</h6> : null}
            <div className={"dependencies-list"}>
            {depends.map((dependency, i) =>
                <ObsDependencyItem key={i}
                    dependency={dependency}
                    active_obs={obs}
                    onSelectObs={()=>{
                        if(obs[ATTR_OBJ_ID] !== dependency[ATTR_OBJ_ID]) this.props.onSelectObs(dependency[ATTR_OBJ_ID])
                    }}
                    callback={() => {
                        BasicModal('Poista yhteys',
                                <section>
                                    <p>Oletko varma että haluat poistaa yhteyden?</p>
                                    <div className={"msg msg-notice"}>
                                        <p>{dependency.text}</p>
                                    </div>
                                    <Spacer />
                                    <p>Poistettuja tietoja ei voi palauttaa toiminnon jälkeen.</p>
                                </section>
                            ,
                            {
                                action: ()=> {
                                    if (this_depends_on) {
                                        this.saveDependencyEdit(obs, dependency, false)
                                    } else {
                                        this.saveDependencyEdit(dependency, obs, false)
                                    }
                                }
                            }
                        )
                    }}
                />
            )}
            </div>
        </>
    }

    renderListing(obs){
        // GET a list of obs items from everyObs corresponding with ATTR_DEPENDS
        let this_depends_on = getThisDependsOn(obs, this.props.everyObs)
        // GET other obs where this is ATTR_DEPENDS
        let depends_on_this = getDependsOnThis(obs, this.props.everyObs)
        // Order dependency list by 'expires'
        this.filter_out_list = this_depends_on.concat([obs], depends_on_this)
        return <>
            {this.renderObsDepends(obs, this_depends_on, 'Yhteydet tästä', true)}
            {this.renderObsDepends(obs, depends_on_this ,'Yhdistetty tähän', false)}
            {this.renderSearchAndAddDependencyObsTextButton()}
            {this.renderSearchResults(obs)}
        </>
    }

    render() {
        let obs = this.props.obs
        if (obs.ui_isHistoryItem || obs.obj_type === OBJ_TYPE_ITM_REF) {
            return null
        }
        if(!this.props.showListing){
            return null
        }
        // Render list of dependency obs
        return <div
                onClick={(evt) => {
                    evt.stopPropagation()
                }}
                className="dependencies margin-top margin-bottom"
            >
            {this.renderListing(obs)}
        </div>
    }
}
